import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  contratoNovoRoute,
  newContratoDescentralizadoRoute,
} from '../../../../library/Routes';
import { MenuItem, Select } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import {
  CONTRATO_PASSOS,
  CONTRATO_FLUXO_DESCENTRALIZADO,
  tipoContratoRoutes,
  STEP_DADOS_COOPERATIVA,
} from '../../../../models/contratos';
import { setCurrentContratoStep } from 'store/modules/AllContratos/AllContratosActions';
import { TipoFluxo } from 'models/contratos';
import './index.scss';
import { closeModal } from 'store/modules/ModalActions';
import { GenericModal } from 'components/GenericModal';
import {
  CONTRATO_EDIT_ETAPA_DADOS,
  CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS,
} from 'library/ContratoEditEtapas';
import { CustomButton } from 'components/CustomButton';
import { Row } from 'components/Row';
import { clearContratoAssessorEditing } from 'store/modules/ContratosFluxoDescentralizado/Assessores/AssessoresActions';
import { clearContratoEntePublicoEditing } from 'store/modules/ContratosFluxoDescentralizado/EntePublico/EntePublicoActions';
import { clearContratoEntePrivadoEditing } from 'store/modules/ContratosFluxoDescentralizado/EntePrivado/EntePrivadoActions';

export const ModalCadastroContrato = (props) => {
  const [selectValue, setSelectValue] = useState(TipoFluxo.DESCENTRALIZADO);
  const languageValues = useSelector(
    (states) => states.languages.languageValues
  );
  const history = useHistory();
  const dispatch = useDispatch();

  const toClose = () => {
    dispatch(closeModal(props.modalKey));
  };

  const toPush = (fullPath) => {
    history.push(fullPath);
    toClose();
  };

  const selectHandleChange = (event) => {
    setSelectValue(event.target.value);
  };

  return (
    <GenericModal
      id={'modalCadastro__contrato-id'}
      onClose={toClose}
      DialogProps={{
        maxWidth: 'xs',
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
      }}
      title={
        <p className='modalCadastro__title'>
          {languageValues.cadastroDeContratos}
        </p>
      }
    >
      <div>
        <Row className='modalCadastro__row-cadastro-contrato'>
          <p className='modalCadastro__text-body-modal'>
            {languageValues.escolhaDefluxoEntidadeCadastroNovoContrato}
          </p>
          <Select
            id='select-contratos'
            className='modalCadastro__select-cadastro-contrato'
            value={selectValue}
            onChange={selectHandleChange}
          >
            <MenuItem id='value_centralizado' value={TipoFluxo.CENTRALIZADO}>
              {languageValues.centralizado}
            </MenuItem>
            <MenuItem
              id='value_descentralizado'
              value={TipoFluxo.DESCENTRALIZADO}
            >
              {languageValues.descentralizado}
            </MenuItem>
          </Select>

          {selectValue === TipoFluxo.CENTRALIZADO ? (
            <>
              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-assessor'}
                label={languageValues.labelButtomCadastrarContratoAssessor}
                onClick={() =>
                  toPush(
                    contratoNovoRoute.getURLWithParams(
                      tipoContratoRoutes.ASSESSOR,
                      CONTRATO_EDIT_ETAPA_DADOS
                    )
                  )
                }
              />

              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-publico'}
                label={languageValues.labelButtomCadastrarContratoEntePublico}
                onClick={() =>
                  toPush(
                    contratoNovoRoute.getURLWithParams(
                      tipoContratoRoutes.ENTE_PUBLICO,
                      CONTRATO_EDIT_ETAPA_DOWNLOAD_CHECKLISTS
                    )
                  )
                }
              />

              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-privado'}
                label={languageValues.labelButtomCadastrarContratoEntePrivado}
                onClick={() =>
                  toPush(
                    contratoNovoRoute.getURLWithParams(
                      tipoContratoRoutes.ENTE_PRIVADO,
                      CONTRATO_EDIT_ETAPA_DADOS
                    )
                  )
                }
              />
            </>
          ) : (
            <>
              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-assessor-descentralizado'}
                label={languageValues.contratoAssessor}
                onClick={() => {
                  dispatch(setCurrentContratoStep(STEP_DADOS_COOPERATIVA));
                  toPush(
                    newContratoDescentralizadoRoute.getURLWithParams(
                      CONTRATO_FLUXO_DESCENTRALIZADO.ASSESSOR,
                      CONTRATO_PASSOS.DADOS_COOPERATIVA
                    )
                  );
                  dispatch(clearContratoAssessorEditing());
                }}
              />

              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-ente-publico-descentralizado'}
                label={
                  languageValues.labelButtomCadastrarContratoEntePublicoDescentralizado
                }
                onClick={() => {
                  dispatch(setCurrentContratoStep(STEP_DADOS_COOPERATIVA));
                  toPush(
                    newContratoDescentralizadoRoute.getURLWithParams(
                      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PUBLICO,
                      CONTRATO_PASSOS.DADOS_COOPERATIVA)
                  )
                  dispatch(clearContratoEntePublicoEditing());
                }}
              />
              <CustomButton
                theme='pufvYellow'
                className='modalCadastro__buttons-cadastro-contrato'
                name={'contrato-ente-privado-descentralizado'}
                label={
                  languageValues.labelButtomCadastrarContratoEntePrivadoDescentralizado
                }
                onClick={() => {
                  dispatch(setCurrentContratoStep(STEP_DADOS_COOPERATIVA));
                  toPush(
                    newContratoDescentralizadoRoute.getURLWithParams(
                      CONTRATO_FLUXO_DESCENTRALIZADO.ENTE_PRIVADO,
                      CONTRATO_PASSOS.DADOS_COOPERATIVA)
                  )
                  dispatch(clearContratoEntePrivadoEditing())
                }}
              />
            </>
          )}
        </Row>
      </div>
    </GenericModal>
  );
};
